<template>
  <div class="flex justify-center">
    <StoreFinderBox
      class="absolute top-[50vh] z-10 mt-4 max-h-[calc(100%-125px)] -translate-y-1/2 overflow-x-auto md:mt-0"
    />
  </div>
  <StoresList
    v-if="allStores && allStores.length"
    class="container"
    :stores="allStores"
  />
</template>

<script setup lang="ts">
const { data: allStores } = useAllShopStores()
</script>
